// import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../Icon';
import styles from './FormInputField.module.scss';

const FormInputField = ({
    placeholder,
    label,
    register,
    type,
    name,
    errors,
    helptext,
    onChange = () => {},
    onKeyDown,
    onClear,
    showClearButton = false,
    value,
    isSearch = false,
}) => {
    return (
        <div
            className={classNames(styles['FormInputField'], {
                [styles['FormInputField--IsSearch']]: isSearch,
                [styles['FormInputField--Clear']]: showClearButton,
            })}>
            <label htmlFor={name} className={styles['FormInputField__Label']}>
                {label}
                {isSearch && (
                    <div className={styles['FormInputField__SearchIcon']}>
                        <Icon type="search" size="small" />
                    </div>
                )}

                <input
                    id={name}
                    type={type}
                    name={name}
                    {...register}
                    placeholder={placeholder}
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    value={value}
                    className={styles['FormInputField__Field']}
                />
                {showClearButton && (
                    <button
                        className={styles['FormInputField__Clear']}
                        onClick={onClear}>
                        <Icon type={'cross'} size="small" />
                    </button>
                )}
            </label>
            {helptext && (
                <p className={styles['FormInputField__HelpText']}>{helptext}</p>
            )}
            {errors && errors[name]?.type === 'required' && (
                <span className={styles['FormInputField__Error']}>
                    This field is required
                </span>
            )}
        </div>
    );
};

FormInputField.propTypes = {};

export default FormInputField;
